<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>下游气夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
          <div class="sensor-source">数据来源: 合并数据</div>
        </div>
        <!-- <div class="legend-station">
                <i class="iconfont iconshebei"></i>
                <span>除湿机</span>
              </div> -->
        <!-- <div class="legend-right">
                <div class="running">设备运行</div>
                <div class="stopped">设备停止</div>
                <div class="default">数据中断</div>
              </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW2, humidityAllowedMaxCW2) }}
              </div>
              <div :class="errorCW2" class="state-info right-pos">
                <p>CW2传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCW2 | toFixed }}% {{ temperatureCW2 | toFixed }}°C <br />
                    {{ pressureCW2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJW2, humidityAllowedMaxJW2) }}
              </div>
              <div :class="errorJW2" class="state-info right-pos">
                <p>JW2传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJW2 | toFixed }}% {{ temperatureJW2 | toFixed }}°C <br />
                    {{ pressureJW2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW4, humidityAllowedMaxCW4) }}
              </div>
              <div :class="errorCW4" class="state-info right-pos">
                <p>CW4传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCW4 | toFixed }}% {{ temperatureCW4 | toFixed }}°C <br />
                    {{ pressureCW4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM2, humidityAllowedMaxCM2) }}
              </div>
              <div :class="errorCM2" class="state-info left-pos">
                <p>CM2传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM2 | toFixed }}% {{ temperatureCM2 | toFixed }}°C <br />
                    {{ pressureCM2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM2, humidityAllowedMaxJM2) }}
              </div>
              <div :class="errorJM2" class="state-info right-pos">
                <p>JM2传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJM2 | toFixed }}% {{ temperatureJM2 | toFixed }}°C <br />
                    {{ pressureJM2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM4, humidityAllowedMaxCM4) }}
              </div>
              <div :class="errorCM4" class="state-info left-pos">
                <p>CM4传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM4 | toFixed }}% {{ temperatureCM4 | toFixed }}°C <br />
                    {{ pressureCM4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM4, humidityAllowedMaxJM4) }}
              </div>
              <div :class="errorJM4" class="state-info right-pos">
                <p>JM4传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJM4 | toFixed }}% {{ temperatureJM4 | toFixed }}°C <br />
                    {{ pressureJM4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM6, humidityAllowedMaxCM6) }}
              </div>
              <div :class="errorCM6" class="state-info top-pos">
                <p>CM6传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM6 | toFixed }}% {{ temperatureCM6 | toFixed }}°C <br />
                    {{ pressureCM6 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM6, humidityAllowedMaxJM6) }}
              </div>
              <div :class="errorJM6" class="state-info left-pos">
                <p>JM6传感器(S)</p>
                <p>
                  <span
                    >{{ humidityJM6 | toFixed }}% {{ temperatureJM6 | toFixed }}°C <br />
                    {{ pressureJM6 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM8, humidityAllowedMaxCM8) }}
              </div>
              <div :class="errorCM8" class="state-info right-pos">
                <p>CM8传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM8 | toFixed }}% {{ temperatureCM8 | toFixed }}°C <br />
                    {{ pressureCM8 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM8, humidityAllowedMaxJM8) }}
              </div>
              <div :class="errorJM8" class="state-info left-pos">
                <p>JM8传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJM8 | toFixed }}% {{ temperatureJM8 | toFixed }}°C <br />
                    {{ pressureJM8 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM10, humidityAllowedMaxCM10) }}
              </div>
              <div :class="errorCM10" class="state-info right-pos">
                <p>CM10传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM10 | toFixed }}% {{ temperatureCM10 | toFixed }}°C <br />
                    {{ pressureCM10 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE4, humidityAllowedMaxCE4) }}
              </div>
              <div :class="errorCE4" class="state-info left-pos">
                <p>CE4传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCE4 | toFixed }}% {{ temperatureCE4 | toFixed }}°C <br />
                    {{ pressureCE4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJE2, humidityAllowedMaxJE2) }}
              </div>
              <div :class="errorJE2" class="state-info left-pos">
                <p>JE2传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJE2 | toFixed }}% {{ temperatureJE2 | toFixed }}°C <br />
                    {{ pressureJE2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE2, humidityAllowedMaxCE2) }}
              </div>
              <div :class="errorCE2" class="state-info left-pos">
                <p>CE2传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCE2 | toFixed }}% {{ temperatureCE2 | toFixed }}°C <br />
                    {{ pressureCE2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>上游气夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
          <div class="sensor-source">数据来源: 合并数据</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW1, humidityAllowedMaxCW1) }}
              </div>
              <div :class="errorCW1" class="state-info right-pos">
                <p>CW1传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCW1 | toFixed }}% {{ temperatureCW1 | toFixed }}°C <br />
                    {{ pressureCW1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJW1, humidityAllowedMaxJW1) }}
              </div>
              <div :class="errorJW1" class="state-info right-pos">
                <p>JW1传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJW1 | toFixed }}% {{ temperatureJW1 | toFixed }}°C <br />
                    {{ pressureJW1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW3, humidityAllowedMaxCW3) }}
              </div>
              <div :class="errorCW3" class="state-info right-pos">
                <p>CW3传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCW3 | toFixed }}% {{ temperatureCW3 | toFixed }}°C <br />
                    {{ pressureCW3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM1, humidityAllowedMaxCM1) }}
              </div>
              <div :class="errorCM1" class="state-info left-pos">
                <p>CM1传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM1 | toFixed }}% {{ temperatureCM1 | toFixed }}°C <br />
                    {{ pressureCM1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM1, humidityAllowedMaxJM1) }}
              </div>
              <div :class="errorJM1" class="state-info right-pos">
                <p>JM1传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJM1 | toFixed }}% {{ temperatureJM1 | toFixed }}°C <br />
                    {{ pressureJM1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM3, humidityAllowedMaxCM3) }}
              </div>
              <div :class="errorCM3" class="state-info left-pos">
                <p>CM3传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM3 | toFixed }}% {{ temperatureCM3 | toFixed }}°C <br />
                    {{ pressureCM3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM3, humidityAllowedMaxJM3) }}
              </div>
              <div :class="errorJM3" class="state-info right-pos">
                <p>JM3传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJM3 | toFixed }}% {{ temperatureJM3 | toFixed }}°C <br />
                    {{ pressureJM3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM5, humidityAllowedMaxCM5) }}
              </div>
              <div :class="errorCM5" class="state-info top-pos">
                <p>CM5传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM5 | toFixed }}% {{ temperatureCM5 | toFixed }}°C <br />
                    {{ pressureCM5 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM5, humidityAllowedMaxJM5) }}
              </div>
              <div :class="errorJM5" class="state-info left-pos">
                <p>JM5传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJM5 | toFixed }}% {{ temperatureJM5 | toFixed }}°C <br />
                    {{ pressureJM5 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM7, humidityAllowedMaxCM7) }}
              </div>
              <div :class="errorCM7" class="state-info right-pos">
                <p>CM7传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM7 | toFixed }}% {{ temperatureCM7 | toFixed }}°C <br />
                    {{ pressureCM7 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM7, humidityAllowedMaxJM7) }}
              </div>
              <div :class="errorJM7" class="state-info left-pos">
                <p>JM7传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJM7 | toFixed }}% {{ temperatureJM7 | toFixed }}°C <br />
                    {{ pressureJM7 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM9, humidityAllowedMaxCM9) }}
              </div>
              <div :class="errorCM9" class="state-info right-pos">
                <p>CM9传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCM9 | toFixed }}% {{ temperatureCM9 | toFixed }}°C <br />
                    {{ pressureCM9 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE3, humidityAllowedMaxCE3) }}
              </div>
              <div :class="errorCE3" class="state-info left-pos">
                <p>CE3传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCE3 | toFixed }}% {{ temperatureCE3 | toFixed }}°C <br />
                    {{ pressureCE3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJE1, humidityAllowedMaxJE1) }}
              </div>
              <div :class="errorJE1" class="state-info left-pos">
                <p>JE1传感器(P)</p>
                <p>
                  <span
                    >{{ humidityJE1 | toFixed }}% {{ temperatureJE1 | toFixed }}°C <br />
                    {{ pressureJE1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE1, humidityAllowedMaxCE1) }}
              </div>
              <div :class="errorCE1" class="state-info left-pos">
                <p>CE1传感器(P)</p>
                <p>
                  <span
                    >{{ humidityCE1 | toFixed }}% {{ temperatureCE1 | toFixed }}°C <br />
                    {{ pressureCE1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature
      humidityCW2: "--",
      humidityJW2: "--",
      humidityCW4: "--",
      humidityCM2: "--",
      humidityJM2: "--",
      humidityCM4: "--",
      humidityJM4: "--",
      humidityCM6: "--",
      humidityJM6: "--",
      humidityCM8: "--",
      humidityJM8: "--",
      humidityCM10: "--",
      humidityCE4: "--",
      humidityJE2: "--",
      humidityCE2: "--",
      humidityCW1: "--",
      humidityJW1: "--",
      humidityCW3: "--",
      humidityCM1: "--",
      humidityJM1: "--",
      humidityCM3: "--",
      humidityJM3: "--",
      humidityCM5: "--",
      humidityJM5: "--",
      humidityCM7: "--",
      humidityJM7: "--",
      humidityCM9: "--",
      humidityCE3: "--",
      humidityJE1: "--",
      humidityCE1: "--",

      temperatureCW2: "--",
      temperatureJW2: "--",
      temperatureCW4: "--",
      temperatureCM2: "--",
      temperatureJM2: "--",
      temperatureCM4: "--",
      temperatureJM4: "--",
      temperatureCM6: "--",
      temperatureJM6: "--",
      temperatureCM8: "--",
      temperatureJM8: "--",
      temperatureCM10: "--",
      temperatureCE4: "--",
      temperatureJE2: "--",
      temperatureCE2: "--",
      temperatureCW1: "--",
      temperatureJW1: "--",
      temperatureCW3: "--",
      temperatureCM1: "--",
      temperatureJM1: "--",
      temperatureCM3: "--",
      temperatureJM3: "--",
      temperatureCM5: "--",
      temperatureJM5: "--",
      temperatureCM7: "--",
      temperatureJM7: "--",
      temperatureCM9: "--",
      temperatureCE3: "--",
      temperatureJE1: "--",
      temperatureCE1: "--",

      pressureCW2: "--",
      pressureJW2: "--",
      pressureCW4: "--",
      pressureCM2: "--",
      pressureJM2: "--",
      pressureCM4: "--",
      pressureJM4: "--",
      pressureCM6: "--",
      pressureJM6: "--",
      pressureCM8: "--",
      pressureJM8: "--",
      pressureCM10: "--",
      pressureCE4: "--",
      pressureJE2: "--",
      pressureCE2: "--",
      pressureCW1: "--",
      pressureJW1: "--",
      pressureCW3: "--",
      pressureCM1: "--",
      pressureJM1: "--",
      pressureCM3: "--",
      pressureJM3: "--",
      pressureCM5: "--",
      pressureJM5: "--",
      pressureCM7: "--",
      pressureJM7: "--",
      pressureCM9: "--",
      pressureCE3: "--",
      pressureJE1: "--",
      pressureCE1: "--",

      //running

      //malfunction

      //error
      errorCW2: "--",
      errorJW2: "--",
      errorCW4: "--",
      errorCM2: "--",
      errorJM2: "--",
      errorCM4: "--",
      errorJM4: "--",
      errorCM6: "--",
      errorJM6: "--",
      errorCM8: "--",
      errorJM8: "--",
      errorCM10: "--",
      errorCE4: "--",
      errorJE2: "--",
      errorCE2: "--",
      errorCW1: "--",
      errorJW1: "--",
      errorCW3: "--",
      errorCM1: "--",
      errorJM1: "--",
      errorCM3: "--",
      errorJM3: "--",
      errorCM5: "--",
      errorJM5: "--",
      errorCM7: "--",
      errorJM7: "--",
      errorCM9: "--",
      errorCE3: "--",
      errorJE1: "--",
      errorCE1: "--",

      //running class

      //humidity allowed max
      humidityAllowedMaxCW2: "--",
      humidityAllowedMaxJW2: "--",
      humidityAllowedMaxCW4: "--",
      humidityAllowedMaxCM2: "--",
      humidityAllowedMaxJM2: "--",
      humidityAllowedMaxCM4: "--",
      humidityAllowedMaxJM4: "--",
      humidityAllowedMaxCM6: "--",
      humidityAllowedMaxJM6: "--",
      humidityAllowedMaxCM8: "--",
      humidityAllowedMaxJM8: "--",
      humidityAllowedMaxCM10: "--",
      humidityAllowedMaxCE4: "--",
      humidityAllowedMaxJE2: "--",
      humidityAllowedMaxCE2: "--",
      humidityAllowedMaxCW1: "--",
      humidityAllowedMaxJW1: "--",
      humidityAllowedMaxCW3: "--",
      humidityAllowedMaxCM1: "--",
      humidityAllowedMaxJM1: "--",
      humidityAllowedMaxCM3: "--",
      humidityAllowedMaxJM3: "--",
      humidityAllowedMaxCM5: "--",
      humidityAllowedMaxJM5: "--",
      humidityAllowedMaxCM7: "--",
      humidityAllowedMaxJM7: "--",
      humidityAllowedMaxCM9: "--",
      humidityAllowedMaxCE3: "--",
      humidityAllowedMaxJE1: "--",
      humidityAllowedMaxCE1: "--",

      //humidity tooltip error
      humidityTooltipErrorCW2: "--",
      humidityTooltipErrorJW2: "--",
      humidityTooltipErrorCW4: "--",
      humidityTooltipErrorCM2: "--",
      humidityTooltipErrorJM2: "--",
      humidityTooltipErrorCM4: "--",
      humidityTooltipErrorJM4: "--",
      humidityTooltipErrorCM6: "--",
      humidityTooltipErrorJM6: "--",
      humidityTooltipErrorCM8: "--",
      humidityTooltipErrorJM8: "--",
      humidityTooltipErrorCM10: "--",
      humidityTooltipErrorCE4: "--",
      humidityTooltipErrorJE2: "--",
      humidityTooltipErrorCE2: "--",
      humidityTooltipErrorCW1: "--",
      humidityTooltipErrorJW1: "--",
      humidityTooltipErrorCW3: "--",
      humidityTooltipErrorCM1: "--",
      humidityTooltipErrorJM1: "--",
      humidityTooltipErrorCM3: "--",
      humidityTooltipErrorJM3: "--",
      humidityTooltipErrorCM5: "--",
      humidityTooltipErrorJM5: "--",
      humidityTooltipErrorCM7: "--",
      humidityTooltipErrorJM7: "--",
      humidityTooltipErrorCM9: "--",
      humidityTooltipErrorCE3: "--",
      humidityTooltipErrorJE1: "--",
      humidityTooltipErrorCE1: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityCW1: "d3b1bf10-928e-4bb9-acd5-c1fee91e3b13",
        humidityJW1: "59568709-cb4b-4db2-9f38-89bd3f8654f4",
        humidityCW3: "585ee7e1-6c62-4992-aee0-41654b256764",
        humidityCM1: "77525f00-ae8e-456a-91fd-c4071e3d4a83",
        humidityJM1: "f11d54f0-fd0c-4027-86a8-e09482111b04",
        humidityCM3: "6832b468-1aff-4d89-8ce9-c9e3d0cd1d59",
        humidityJM3: "a1cdb39c-0441-429f-8a4f-92483bfee473",
        humidityCM5: "25df4eac-6931-4548-87dd-6ddb19b68c37",
        humidityCW2: "90d22f0d-6512-49fd-a29d-b3c27fafcf38",
        humidityJW2: "3fbf669f-fc33-4547-b7e6-bfe99cd07a8c",
        humidityCW4: "eb1b76de-5547-4723-bbb6-03e974ab3967",
        humidityCM2: "4f3c2b6a-90db-4b4c-b2f2-d07cf3d1244b",
        humidityJM2: "11f7f8d7-6b1e-4d64-930f-665299150ae5",
        humidityCM4: "eff18d31-b607-48b6-9d71-64d0ff0cf0ec",
        humidityJM4: "c46f342c-cca2-4e61-b760-b1286e9b88de",
        humidityCM6: "65caee29-b17b-428a-ba82-9435729f327f",
        humidityCE2: "2ddf63b0-0dd0-468b-8dbe-2ebe462ff478",
        humidityJM5: "529c5386-1e87-40da-8a0b-9ac4ed303042",
        humidityCM7: "e6d17c7b-0c5c-4e94-a7bc-18812f77bf79",
        humidityJM7: "59a25ba1-9a6c-48da-8f44-33cfbb4af9af",
        humidityCM9: "e42c6605-e745-4f96-9964-9d594ad2a761",
        humidityCE3: "45331332-6dca-4362-bd9f-7be1588fda9e",
        humidityJE1: "7b864e79-d40f-40e8-8b1b-aaca7bcb136e",
        humidityCE1: "11af71f8-53c7-4d59-ba6b-1c3540388741",
        humidityJM6: "249156f1-12c2-4853-b883-8cf9c1fcfb68",
        humidityCM8: "8f2e2734-2e65-485a-9c80-7428c7862a62",
        humidityJM8: "0509a1f1-96ef-46ad-80eb-3fcfd2e7e19e",
        humidityCM10: "fcf3e6a5-7f17-44fe-8337-a3fed5247c6c",
        humidityCE4: "3c409ee8-d442-449a-b02a-c4b6f9af8183",
        humidityJE2: "9253b5e9-e790-4b63-bfcb-0c980f5b0d52",

        temperatureCW1: "bc3daead-c1e8-45b8-9093-8b114917a4a2",
        temperatureJW1: "af8d306b-bfed-46e6-9cb8-2064aa70f5f3",
        temperatureCW3: "fc67b23f-62a8-477e-aa9a-6f2e0e5bb8d7",
        temperatureCM1: "6c67d51c-0fb3-4852-b215-0416713ec328",
        temperatureJM1: "408d3025-9741-4f0d-a7c6-45d9b84cd1ff",
        temperatureCM3: "1720f135-ecd4-42ef-bf06-4f160c6dbefd",
        temperatureJM3: "d8e4a943-aaec-4cc8-b858-3af45e60c74c",
        temperatureCM5: "4d154d1b-d93b-4bc4-a6de-32466d21c6cd",
        temperatureCW2: "0d0e36af-c561-40ed-86ab-9d72e65f504f",
        temperatureJW2: "9befd448-99d1-4283-94f9-40508d2f97a8",
        temperatureCW4: "2727007f-0d42-4cb8-8700-550a86227b9c",
        temperatureCM2: "64c5c896-5008-41f3-81b3-6e35a5bf2f9e",
        temperatureJM2: "660c3741-de65-422f-b436-0074f8c5615f",
        temperatureCM4: "25b91cf5-f994-4bfc-9269-5d6d0e3edb70",
        temperatureJM4: "7287b7ce-7e91-4aac-9b61-bc0659f65317",
        temperatureCM6: "c6f3bd7b-8086-4bdb-886b-076d54b8bc96",
        temperatureCE2: "d4e491b5-33f8-4745-9a22-749786c1195e",
        temperatureJM5: "52f5303d-8d4e-4e6c-939a-6e0c0c76212e",
        temperatureCM7: "0e3175f4-c245-46f1-ab5b-6bde6a303a3b",
        temperatureJM7: "d8660752-2c8e-4f8c-9d5e-74032cb6ecc7",
        temperatureCM9: "326859bd-11e5-42aa-a311-12cb7200c941",
        temperatureCE3: "72d696cd-0eb2-4265-a456-c6b1432a15ab",
        temperatureJE1: "5340cf5c-4e92-4a93-bf6d-bd77ba54679c",
        temperatureCE1: "8c6c6b62-c475-42c2-a521-bae4a5e4c384",
        temperatureJM6: "413aca6d-2cee-401b-a5f0-d7ef87d5c423",
        temperatureCM8: "876fb749-f8fc-4e6b-951c-61d20555e0a8",
        temperatureJM8: "c8c27bf9-defe-47c1-80a5-85cb184867a7",
        temperatureCM10: "e22a9d94-defc-4607-9b90-0438f934c6ac",
        temperatureCE4: "d78792d3-d008-4c74-b8f7-ebbf249be8af",
        temperatureJE2: "67ee9ddf-4f7d-4a5f-a82c-64c639261fc2",

        pressureCW1: "5e6fda41-1a0b-46b2-8435-4b15651774ee",
        pressureJW1: "2e02e812-f083-4b46-9487-ba9d7d152b4f",
        pressureCW3: "c1ec9c66-1798-4461-9885-52f5a4630667",
        pressureCM1: "387c4fc6-cd24-4dcb-a204-381bd06733cf",
        pressureJM1: "6e779288-f209-49bb-a861-39585fe4f593",
        pressureCM3: "80b0a2a9-fd46-4023-8666-7c6a89d84f83",
        pressureJM3: "e2d39521-8683-49aa-8a46-bb70e6cf5545",
        pressureCM5: "013708f0-3ced-4da1-a6c5-9cdeed972ed9",
        pressureCW2: "daba687d-3993-4173-9c41-2d4d4eeeab5c",
        pressureJW2: "604d777c-4bdd-4315-a05b-ade07020fe3e",
        pressureCW4: "e7bb1983-e64c-43e4-98e2-fdf6a1b89206",
        pressureCM2: "3c7af35e-5692-4f14-94de-62a941e64a55",
        pressureJM2: "a1cf9f29-c817-4738-8855-cd2dbfc02ef5",
        pressureCM4: "7e8939ca-3551-4353-afa7-da7302d62bd7",
        pressureJM4: "e02ce7b1-e7df-4381-8fbc-c74205285600",
        pressureCM6: "3f337b5b-6f5d-4c25-8c5b-ded2f44713b6",
        pressureCE2: "0837046b-957b-479a-9dda-d332bacd2a15",
        pressureJM5: "0a2dae30-1617-4bd7-9c2d-83c59b74747f",
        pressureCM7: "68deba3d-7aee-45fa-abe1-f8b7715d3d4f",
        pressureJM7: "e58bab8b-07c8-4226-911f-b8950e358ee5",
        pressureCM9: "97abed65-3429-4677-b0fd-975585952709",
        pressureCE3: "1fdde553-ce3e-4fe0-bcab-ce3e50d76b16",
        pressureJE1: "ce915931-33d6-49fa-8432-2b2f89ce8727",
        pressureCE1: "9da484aa-f3d9-49b9-9147-1f7cd2ec99fd",
        pressureJM6: "7adcad38-228d-488c-9368-44de09d8f616",
        pressureCM8: "ade8c283-d1bc-456b-9db6-0240e49962b1",
        pressureJM8: "720c78c8-75c7-40a8-bf00-39fb08d7e2d1",
        pressureCM10: "54c3ce1f-0819-4ea0-a643-0d4300c51c5d",
        pressureCE4: "12ba3585-965f-45ba-ae70-afd194d51480",
        pressureJE2: "0a586411-9e69-48e8-8508-d755d02850cd",

        //running

        //malfunction
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxCW1: "d3b1bf10-928e-4bb9-acd5-c1fee91e3b13",
        humidityAllowedMaxJW1: "59568709-cb4b-4db2-9f38-89bd3f8654f4",
        humidityAllowedMaxCW3: "585ee7e1-6c62-4992-aee0-41654b256764",
        humidityAllowedMaxCM1: "77525f00-ae8e-456a-91fd-c4071e3d4a83",
        humidityAllowedMaxJM1: "f11d54f0-fd0c-4027-86a8-e09482111b04",
        humidityAllowedMaxCM3: "6832b468-1aff-4d89-8ce9-c9e3d0cd1d59",
        humidityAllowedMaxJM3: "a1cdb39c-0441-429f-8a4f-92483bfee473",
        humidityAllowedMaxCM5: "25df4eac-6931-4548-87dd-6ddb19b68c37",
        humidityAllowedMaxCW2: "90d22f0d-6512-49fd-a29d-b3c27fafcf38",
        humidityAllowedMaxJW2: "3fbf669f-fc33-4547-b7e6-bfe99cd07a8c",
        humidityAllowedMaxCW4: "eb1b76de-5547-4723-bbb6-03e974ab3967",
        humidityAllowedMaxCM2: "4f3c2b6a-90db-4b4c-b2f2-d07cf3d1244b",
        humidityAllowedMaxJM2: "11f7f8d7-6b1e-4d64-930f-665299150ae5",
        humidityAllowedMaxCM4: "eff18d31-b607-48b6-9d71-64d0ff0cf0ec",
        humidityAllowedMaxJM4: "c46f342c-cca2-4e61-b760-b1286e9b88de",
        humidityAllowedMaxCM6: "65caee29-b17b-428a-ba82-9435729f327f",
        humidityAllowedMaxCE2: "2ddf63b0-0dd0-468b-8dbe-2ebe462ff478",
        humidityAllowedMaxJM5: "529c5386-1e87-40da-8a0b-9ac4ed303042",
        humidityAllowedMaxCM7: "e6d17c7b-0c5c-4e94-a7bc-18812f77bf79",
        humidityAllowedMaxJM7: "59a25ba1-9a6c-48da-8f44-33cfbb4af9af",
        humidityAllowedMaxCM9: "e42c6605-e745-4f96-9964-9d594ad2a761",
        humidityAllowedMaxCE3: "45331332-6dca-4362-bd9f-7be1588fda9e",
        humidityAllowedMaxJE1: "7b864e79-d40f-40e8-8b1b-aaca7bcb136e",
        humidityAllowedMaxCE1: "11af71f8-53c7-4d59-ba6b-1c3540388741",
        humidityAllowedMaxJM6: "249156f1-12c2-4853-b883-8cf9c1fcfb68",
        humidityAllowedMaxCM8: "8f2e2734-2e65-485a-9c80-7428c7862a62",
        humidityAllowedMaxJM8: "0509a1f1-96ef-46ad-80eb-3fcfd2e7e19e",
        humidityAllowedMaxCM10: "fcf3e6a5-7f17-44fe-8337-a3fed5247c6c",
        humidityAllowedMaxCE4: "3c409ee8-d442-449a-b02a-c4b6f9af8183",
        humidityAllowedMaxJE2: "9253b5e9-e790-4b63-bfcb-0c980f5b0d52",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityCW2: "errorCW2",
        humidityJW2: "errorJW2",
        humidityCW4: "errorCW4",
        humidityCM2: "errorCM2",
        humidityJM2: "errorJM2",
        humidityCM4: "errorCM4",
        humidityJM4: "errorJM4",
        humidityCM6: "errorCM6",
        humidityJM6: "errorJM6",
        humidityCM8: "errorCM8",
        humidityJM8: "errorJM8",
        humidityCM10: "errorCM10",
        humidityCE4: "errorCE4",
        humidityJE2: "errorJE2",
        humidityCE2: "errorCE2",
        humidityCW1: "errorCW1",
        humidityJW1: "errorJW1",
        humidityCW3: "errorCW3",
        humidityCM1: "errorCM1",
        humidityJM1: "errorJM1",
        humidityCM3: "errorCM3",
        humidityJM3: "errorJM3",
        humidityCM5: "errorCM5",
        humidityJM5: "errorJM5",
        humidityCM7: "errorCM7",
        humidityJM7: "errorJM7",
        humidityCM9: "errorCM9",
        humidityCE3: "errorCE3",
        humidityJE1: "errorJE1",
        humidityCE1: "errorCE1",

        temperaturerCW2: "errorCW2",
        temperaturerJW2: "errorJW2",
        temperaturerCW4: "errorCW4",
        temperaturerCM2: "errorCM2",
        temperaturerJM2: "errorJM2",
        temperaturerCM4: "errorCM4",
        temperaturerJM4: "errorJM4",
        temperaturerCM6: "errorCM6",
        temperaturerJM6: "errorJM6",
        temperaturerCM8: "errorCM8",
        temperaturerJM8: "errorJM8",
        temperaturerCM10: "errorCM10",
        temperaturerCE4: "errorCE4",
        temperaturerJE2: "errorJE2",
        temperaturerCE2: "errorCE2",
        temperaturerCW1: "errorCW1",
        temperaturerJW1: "errorJW1",
        temperaturerCW3: "errorCW3",
        temperaturerCM1: "errorCM1",
        temperaturerJM1: "errorJM1",
        temperaturerCM3: "errorCM3",
        temperaturerJM3: "errorJM3",
        temperaturerCM5: "errorCM5",
        temperaturerJM5: "errorJM5",
        temperaturerCM7: "errorCM7",
        temperaturerJM7: "errorJM7",
        temperaturerCM9: "errorCM9",
        temperaturerCE3: "errorCE3",
        temperaturerJE1: "errorJE1",
        temperaturerCE1: "errorCE1",

        pressureCW2: "errorCW2",
        pressureJW2: "errorJW2",
        pressureCW4: "errorCW4",
        pressureCM2: "errorCM2",
        pressureJM2: "errorJM2",
        pressureCM4: "errorCM4",
        pressureJM4: "errorJM4",
        pressureCM6: "errorCM6",
        pressureJM6: "errorJM6",
        pressureCM8: "errorCM8",
        pressureJM8: "errorJM8",
        pressureCM10: "errorCM10",
        pressureCE4: "errorCE4",
        pressureJE2: "errorJE2",
        pressureCE2: "errorCE2",
        pressureCW1: "errorCW1",
        pressureJW1: "errorJW1",
        pressureCW3: "errorCW3",
        pressureCM1: "errorCM1",
        pressureJM1: "errorJM1",
        pressureCM3: "errorCM3",
        pressureJM3: "errorJM3",
        pressureCM5: "errorCM5",
        pressureJM5: "errorJM5",
        pressureCM7: "errorCM7",
        pressureJM7: "errorJM7",
        pressureCM9: "errorCM9",
        pressureCE3: "errorCE3",
        pressureJE1: "errorJE1",
        pressureCE1: "errorCE1",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {},

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityCW2: "humidityTooltipErrorCW2",
        humidityJW2: "humidityTooltipErrorJW2",
        humidityCW4: "humidityTooltipErrorCW4",
        humidityCM2: "humidityTooltipErrorCM2",
        humidityJM2: "humidityTooltipErrorJM2",
        humidityCM4: "humidityTooltipErrorCM4",
        humidityJM4: "humidityTooltipErrorJM4",
        humidityCM6: "humidityTooltipErrorCM6",
        humidityJM6: "humidityTooltipErrorJM6",
        humidityCM8: "humidityTooltipErrorCM8",
        humidityJM8: "humidityTooltipErrorJM8",
        humidityCM10: "humidityTooltipErrorCM10",
        humidityCE4: "humidityTooltipErrorCE4",
        humidityJE2: "humidityTooltipErrorJE2",
        humidityCE2: "humidityTooltipErrorCE2",
        humidityCW1: "humidityTooltipErrorCW1",
        humidityJW1: "humidityTooltipErrorJW1",
        humidityCW3: "humidityTooltipErrorCW3",
        humidityCM1: "humidityTooltipErrorCM1",
        humidityJM1: "humidityTooltipErrorJM1",
        humidityCM3: "humidityTooltipErrorCM3",
        humidityJM3: "humidityTooltipErrorJM3",
        humidityCM5: "humidityTooltipErrorCM5",
        humidityJM5: "humidityTooltipErrorJM5",
        humidityCM7: "humidityTooltipErrorCM7",
        humidityJM7: "humidityTooltipErrorJM7",
        humidityCM9: "humidityTooltipErrorCM9",
        humidityCE3: "humidityTooltipErrorCE3",
        humidityJE1: "humidityTooltipErrorJE1",
        humidityCE1: "humidityTooltipErrorCE1",
      },

      //running -> running class
      dataNameRunningClassNameDict: {},

      //station id list
      stationIdList: [
        "351dbb31-4db5-4bd0-b572-8173261fdd6f",
        "fa5b3f6c-ceab-4205-b52c-66b42cfcc00d",
        "2d1c521f-a564-4293-83df-f34eaff00872",
        "1a8e4981-4931-4429-a238-dd4765d126a6",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1405px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 25px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
        .sensor-source {
          margin-left: -35px;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1400px;
        height: 250px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jinshajiang/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 45%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 46%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sta-left {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-left-tower {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle-tower {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right-tower {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex1 {
          top: 152px;
          left: 200px;
          &::before {
            top: -34px;
            left: -33px;
            width: 70px;
            transform: rotate(79deg);
          }
          &::after {
            top: -68px;
            left: -19px;
          }
          .state-info {
            right: 37px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex2 {
          top: 120px;
          left: 285px;
          &::before {
            top: 74px;
            left: -74px;
            width: 130px;
            transform: rotate(107deg);
          }

          &::after {
            top: 135px;
            left: -44px;
          }

          .state-info {
            right: 62px;
            top: 136px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex3 {
          top: 81px;
          left: 370px;

          &::before {
            top: -33px;
            left: -38px;
            width: 70px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 45px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex4 {
          top: 81px;
          left: 399px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex5 {
          top: 100px;
          left: 455px;
          &::before {
            top: 76px;
            right: -46px;
            width: 126px;
            transform: rotate(-80deg);
          }

          &::after {
            top: 138px;
            left: -32px;
            width: 20px;
          }

          .state-info {
            right: 45px;
            top: 139px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex6 {
          top: 120px;
          left: 524px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex7 {
          top: 134px;
          left: 604px;
          &::before {
            top: 63px;
            width: 100px;
            right: -33px;
            transform: rotate(-79deg);
          }

          &::after {
            top: 111px;
            left: -26px;
          }

          .state-info {
            right: 43px;
            top: 112px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex8 {
          top: 140px;
          left: 686px;
          &::before {
            top: 20px;
            left: -6px;
            width: 28px;
            transform: rotate(270deg);
          }

          &::after {
            display: none;
            left: 21px;
          }

          .state-info {
            left: 50%;
            top: 35px;
            transform: translateX(-49%);
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex9 {
          top: 130px;
          left: 769px;
          &::before {
            top: 63px;
            width: 100px;
            left: -33px;
            transform: rotate(79deg);
          }

          &::after {
            top: 111px;
            left: 27px;
          }

          .state-info {
            left: 44px;
            top: 112px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex10 {
          top: 121px;
          left: 835px;
          &::before {
            bottom: 48px;
            right: -18px;
            width: 70px;
            transform: rotate(79deg);
          }

          &::after {
            top: -68px;
            left: -22px;
          }

          .state-info {
            right: 35px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex11 {
          top: 100px;
          left: 910px;
          &::before {
            top: 79px;
            left: -46px;
            width: 133px;
            transform: rotate(80deg);
          }

          &::after {
            bottom: -130px;
            left: 33px;
          }

          .state-info {
            left: 50px;
            top: 145px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
        .ex12 {
          top: 81px;
          left: 958px;

          &::before {
            top: -33px;
            left: -38px;
            width: 70px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 41px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex13 {
          top: 81px;
          left: 988px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex14 {
          top: 118px;
          left: 1090px;
          &::before {
            top: 70px;
            width: 116px;
            left: -44px;
            transform: rotate(82deg);
          }

          &::after {
            bottom: -112px;
            left: 23px;
          }

          .state-info {
            left: 40px;
            top: 127px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex15 {
          top: 153px;
          left: 1210px;
          &::before {
            top: -34px;
            right: -33px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -68px;
            right: -19px;
          }

          .state-info {
            left: 37px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>
